import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/account/";

//获取收藏列表
export function get_symbolStar(config) {
  return XtAxios4.get(URL + `symbol-star/list`, config);
}

//加入收藏列表
export function post_symbolStar(config) {
  // POST /sapi/v4/account/symbol-star/add?symbol=btc_brl_cfd
  // symbol 作为 query 参数传递
  return XtAxios4.post(URL + `symbol-star/add`, null, config);
}

//取消收藏列表
export function delete_symbolStarId(symbol, config) {
  // 根据接口文档，使用 DELETE 请求，symbol 在路径中
  // DELETE /sapi/v4/account/symbol-star/cancel/btc_brl_cfd
  return XtAxios4.delete(URL + `symbol-star/cancel/${symbol}`, config);
}

// 批量编辑收藏顺序（body: { symbols: "a,b,c" }）
export function post_symbolStar_edit(data, config) {
  return XtAxios4.post(URL + "symbol-star/edit", data, config);
}
